const JUNIP_STORE_KEY = 'aKrV5YbgHBy5eriUdzLb6wSg';

class Reviews {
  /** @type {HTMLSpanElement} Element with .js-reviews-average class */
  reviewsAverage

  /** @type {HTMLSpanElement[]} All elements with .js-reviews-counter class */
  reviewsCounter

  /** @type {HTMLDivElement} Element with .js-reviews-container class */
  reviewsContainer

  constructor () {
    this.setDependencyElements();
    this.populateReviews();
  }

  setDependencyElements() {
    const reviewsAverage = document.querySelector('.js-reviews-average');
    const reviewsCounter = document.querySelectorAll('.js-reviews-counter');
    const reviewsContainer = document.querySelector('.js-reviews-container');

    if (
      reviewsAverage === null
      || reviewsCounter.length === 0
      || reviewsContainer === null
    ) {
      throw new Error('Missing dependency elements');
      return;
    }

    this.reviewsAverage = reviewsAverage;
    this.reviewsCounter = reviewsCounter;
    this.reviewsContainer = reviewsContainer;
  }

  async populateReviews() {
    const reviews = await this.doRequest();
    let reviewsFiltered = [];

    let reviewTags = document.querySelector('h1.product-single__title').dataset.tags;

    if(reviewTags){
      let tags = reviewTags.split(',');
      for (let i = 0; i < reviews.length; i++) {
        let productTitle = reviews[i].product.title.toLowerCase();
          let valid = true;
          for (let j = 0; j < tags.length; j++) {
              let notInclude = '';
              if(tags[j] == 'men'){
                  notInclude = 'women';
              }
  
              if(notInclude){
                  if(!productTitle.includes(tags[j]) || productTitle.includes(notInclude)){
                      valid = false;
                  }
              }else{
                  if(!productTitle.includes(tags[j])){
                      valid = false;
                  }
              }
          }
  
          if(valid){
            reviewsFiltered.push(reviews[i]);
          }
      } 
    }

    if(reviewsFiltered.length > 0){
      this.formatReviews(reviewsFiltered);
    }
  }

  /**
   * @param {string[]} productsId
   * @param {string | undefined}
   */
  async doRequest( page = undefined) {
    // const formattedProductsId = productsId.join(',');
    let url = `https://api.juniphq.com/v1/product_reviews?include=customer,product&sort[field]=created_at&sort[order]=desc`;
    let allReviews = [];
    if (page !== undefined) {
      url = `${url}&page[after]=${page}`;
    }

    const response = await fetch(
      url,
      {
        headers: {
          'Junip-Store-Key': JUNIP_STORE_KEY,
        }
      }
    );

    const request = await response.json();

    if (request.meta !== undefined && request.meta.page.after !== null) {
      const recursiveResult = await this.doRequest(request.meta.page.after);
      allReviews = [...allReviews, ...recursiveResult];
    }

    allReviews = [...allReviews, ...request.product_reviews];
    
    return allReviews;
  }

  /**
   * @param {object[]} allReviews
   */
  formatReviews(allReviews) {
    var scores = [];

    allReviews.forEach((review) => {
      scores.push(review.rating);
    });

    let sum = scores.reduce(function (a, b) {
      return a + b;
    });

    let findAverage = (sum / scores.length).toFixed(1);

    this.populateData(findAverage, allReviews)
  }

  /**
   * @param {number} average
   * @param {object[]} allReviews
   */
  populateData(average, allReviews) {
    this.reviewsAverage.innerText = average;
    this.reviewsCounter.forEach((counter) => counter.innerText = allReviews.length);
  
    allReviews.sort((a, b) => {
      const nameA = a.created_at; // ignore upper and lowercase
      const nameB = b.created_at; // ignore upper and lowercase
     
      return new Date(nameB) - new Date(nameA);
    });

    // Show all reviews
    let all_review_html = '';
    allReviews.forEach((review) => {
      let date_options = { year: 'numeric', month: 'long', day: 'numeric' };
      let review_date = new Date(review.created_at);
      all_review_html += `<div class="reiews">
        <div class="name-year">
          <h2>${review.customer.first_name} ${review.customer.last_name}</h2>
          ${review.verified_buyer ? '<h2><img style="margin-right: 10px;" src="https://cdn.shopify.com/s/files/1/0502/0647/4424/files/Vector_aadc0212-189d-4caa-8c4c-3d41aceb8172.png?v=1665412560" alt="Checked" width="16" height="16">VERIFIED BUYER</h2>' : '' }
          <h2>${review_date.toLocaleString('en-US', date_options).toString().toUpperCase()}</h2>
        </div>
        <div class="description-reviews">
          <div class="icon-star">${'<span class="full">★</span>'.repeat(review.rating)}${review.rating < 5 ? '<span class="empty_star">★</span>'.repeat(5 - review.rating) : '' }</div>
          <h3>${review.title}</h3>
          <p>${review.body}</p>
        </div>
        ${ review.photo_urls.length > 0 ? '<img class="image-reviews" src="'+review.photo_urls[0].thumbnail+'" />' : ''}
      </div>`;  
    });
    
    if(all_review_html != '') { this.reviewsContainer.insertAdjacentHTML('afterbegin', all_review_html); }
    let intervar_pagination = setInterval(() => {
      if(document.querySelectorAll(".js-reviews-container.content-reviews .reiews") != null ){
        clearInterval(intervar_pagination);
        this.pagination();
      }
    }, 300);
    
  }
  
  pagination(){
    
    const paginationNumbers = document.querySelector(".pagination-reviews ul");
    const paginatedList = document.querySelector(".js-reviews-container.content-reviews");
    const listItems = paginatedList.querySelectorAll(".js-reviews-container.content-reviews .reiews");
    const nextButton = document.querySelector(".icon-pagination.next ");
    const prevButton = document.querySelector(".icon-pagination.prev");
    
    
    const paginationLimit = 3;
    const pageCount = Math.ceil(listItems.length / paginationLimit);
    let currentPage = 1;
    
    const disableButton = (button) => {
      button.classList.add("disabled");
      button.setAttribute("disabled", true);
    };
    
    const enableButton = (button) => {
      button.classList.remove("disabled");
      button.removeAttribute("disabled");
    };
    
    const handlePageButtonsStatus = () => {
      if (currentPage === 1) {
        disableButton(prevButton);
      } else {
        enableButton(prevButton);
      }
    
      if (pageCount === currentPage) {
        disableButton(nextButton);
      } else {
        enableButton(nextButton);
      }
    };
    
    const handleActivePageNumber = () => {
      document.querySelectorAll(".pagination-number").forEach((button) => {
        button.classList.remove("active");
        const pageIndex = Number(button.getAttribute("page-index"));
        if (pageIndex == currentPage) {
          button.classList.add("active");
        }
        
        if(currentPage > 2 && pageIndex < (currentPage + 2) && pageIndex > (currentPage-2) ){
          button.classList.remove("hide");
          if(currentPage > 2 && currentPage < 6){
            document.querySelector('.dots-first').classList.add('hide');
            document.querySelector('.dots-last').classList.remove('hide');
          }else if (currentPage > (pageCount - 5) && currentPage <= pageCount){
            document.querySelector('.dots-first').classList.remove('hide');
            document.querySelector('.dots-last').classList.add('hide');
          }else{
            document.querySelector('.dots-first').classList.remove('hide');
            document.querySelector('.dots-last').classList.remove('hide');
            let _tmp_r = document.querySelector(`.pagination-number[page-index="${(currentPage-2)}"]`);
            let _tmp_l = document.querySelector(`.pagination-number[page-index="${(currentPage+2)}"]`); 
            _tmp_r != null ? _tmp_r.classList.add('hide') : '';
            _tmp_l != null ? _tmp_l.classList.add('hide') : '';
          }
        }else if ((pageIndex > 3 && pageIndex < (pageCount - 2) )){
          button.classList.add("hide");
          currentPage <= 2 ? document.querySelector('.dots-last').classList.add('hide') : '';
          currentPage <= 2 ? document.querySelector('.dots-first').classList.remove('hide') : '';
        }
      });
    };
    
    const appendPageNumber = (index) => {
      let extra_class = '';
      if( pageCount > 6 && (index > 3 && index < (pageCount - 2))  ){
        extra_class = 'hide';
      }
            
      const pageNumber = `<li class="pagination-number ${extra_class}" page-index="${index}" aria-label="Pagge ${index}" ><a href="javascript:void(0)">${index}</a></li>`;
      
      if(extra_class != '' && index == 4 || pageCount > 8 && index == (pageCount - 2)){
        paginationNumbers.insertAdjacentHTML("beforeend", `<li class="dots-${index == 4 ? 'first' : 'last hide'}" page-index="dots" aria-label="Pagge dots" ><a href="javascript:void(0)">...</a></li>`);
      }
      
      paginationNumbers.insertAdjacentHTML("beforeend", pageNumber);
      
    };
    
    const getPaginationNumbers = () => {
      for (let i = 1; i <= pageCount; i++) {
        appendPageNumber(i);
      }
    };
    
    const setCurrentPage = (pageNum) => {
      currentPage = pageNum;
    
      handleActivePageNumber();
      handlePageButtonsStatus();
      
      const prevRange = (pageNum - 1) * paginationLimit;
      const currRange = pageNum * paginationLimit;
    
      listItems.forEach((item, index) => {
        item.classList.add("hidden");
        if (index >= prevRange && index < currRange) {
          item.classList.remove("hidden");
        }
      });
    };
    
    getPaginationNumbers();
    setCurrentPage(1);
  
    prevButton.addEventListener("click", () => {
      setCurrentPage(currentPage - 1);
    });
  
    nextButton.addEventListener("click", () => {
      setCurrentPage(currentPage + 1);
    });
  
    document.querySelectorAll(".pagination-number").forEach((button) => {
      const pageIndex = Number(button.getAttribute("page-index"));
  
      if (pageIndex) {
        button.addEventListener("click", () => {
          setCurrentPage(pageIndex);
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new Reviews();
});
